import { useInfiniteQuery, useMutation } from '@tanstack/react-query';
import { get } from 'lodash';
import { ApiRoutes } from '../api/ApiRoutes';
import { useAxios } from '../api/AxiosContext';

// interface Props {}

export const useHistoryInfiniteQuery = () => {
  const axios = useAxios();

  return useInfiniteQuery(
    ['history-listing'],
    ({ pageParam = 1 }) => {
      return axios.get(ApiRoutes.histories, {
        params: { page: pageParam },
      });
    },
    {
      getNextPageParam: lastPage => {
        if (lastPage?.data?.links.next) {
          return get(lastPage, 'data.meta.currentPage', 0) + 1;
        }

        return undefined;
      },
      select: data => ({
        ...data,
        pages: data.pages,
      }),
      enabled: false,
      keepPreviousData: false,
      cacheTime: 0,
    },
  );
};

export const useHistoryUpcomingMutation = () => {
  const axios = useAxios();

  return useMutation(
    ['history-upcoming'],
    () => {
      return axios.get(ApiRoutes.historiesUpcoming, {
        params: {
          page: 1,
        },
      });
    },
    {
      cacheTime: 0,
    },
  );
};
